import React, { useState } from "react";
import { PhoneInputWrapper, Wrapper } from "./style";
import { CountryCode } from "libphonenumber-js/types";
import {
    getNationalDigitCount,
    getPhoneCallingCode,
    limitPhoneNationalDigits,
} from "../../../utils/helpers";

interface InputProps {
    label?: string;
    placeholder?: string;
    field?: any;
    isSecondaryBackground?: boolean;
    hasError?: boolean;
    height?: string;
    defaultCountry?:string;
    showPhoneCode?: boolean;
    disableLabel?: boolean;
    maxLength?: number;
}

export const InputPhone = ({
    label = "Phone number",
    isSecondaryBackground = false,
    field,
    hasError = false,
    height,
    defaultCountry = "NG",
    showPhoneCode = false,
    disableLabel = false,
    maxLength,
}: InputProps) => {
    const [hasFocus, setHasFocus] = useState(false);
    const [, setSelectedCountry] = useState<CountryCode>("NG");
    const callingCode = getPhoneCallingCode(defaultCountry);

    const applyNationalLimit = (value?: string) => {
        if (!maxLength) return value;
        return limitPhoneNationalDigits(value, maxLength, callingCode || "234");
    };

    return (
        <Wrapper
            $isSecondaryBackground={isSecondaryBackground}
            $hasError={hasError}
            onFocus={() => {
                setHasFocus(true);
            }}
            onBlur={() => {
                setHasFocus(false);
            }}
            $height={height}
            $showPhoneCode={showPhoneCode}
        >
            <p
                className={`input-label ${hasFocus && !disableLabel ? "top" : ""} ${field?.value?.length ? "has-value top" : ""
                    }`}
            >
                {label}
            </p>

            <PhoneInputWrapper
                placeholder={!hasFocus && disableLabel && label}
                {...field}
                onChange={(value?: string) => {
                    field?.onChange(applyNationalLimit(value));
                }}
                numberInputProps={{
                    inputMode: "numeric",
                    onBeforeInput: (event: React.FormEvent<HTMLInputElement> & { data?: string }) => {
                        if (!maxLength) return;
                        const nativeEvent = event.nativeEvent as InputEvent;
                        const incoming = nativeEvent.data;
                        if (!incoming || !/\d/.test(incoming)) return;

                        const currentValue = event.currentTarget.value;
                        if (getNationalDigitCount(currentValue, callingCode) >= maxLength) {
                            event.preventDefault();
                        }
                    },
                    onInput: (event: React.FormEvent<HTMLInputElement>) => {
                        if (!maxLength) return;
                        const currentValue = event.currentTarget.value;
                        if (getNationalDigitCount(currentValue, callingCode) > maxLength) {
                            field?.onChange(applyNationalLimit(currentValue));
                        }
                    },
                    onPaste: (event: React.ClipboardEvent<HTMLInputElement>) => {
                        if (!maxLength) return;
                        event.preventDefault();
                        const currentDigits = event.currentTarget.value.replace(/\D/g, "");
                        const pastedDigits = event.clipboardData.getData("text").replace(/\D/g, "");
                        const combinedDigits = `${currentDigits}${pastedDigits}`;
                        const nextValue = combinedDigits.startsWith(callingCode)
                            ? `+${combinedDigits}`
                            : combinedDigits;
                        field?.onChange(applyNationalLimit(nextValue));
                    },
                }}
                countrySelectProps={{
                    unicodeFlags: false,
                }}
                onCountryChange={setSelectedCountry}
                defaultCountry={defaultCountry}
                withCountryCallingCode
                international={showPhoneCode}
            />

        </Wrapper>
    );
};
